(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["c-sku-display"] && !Shopify.designMode) return;
  try {
    class ProductSKU extends HTMLElement {
    
    constructor() {
      super();
      this.abortController = new AbortController();
    }

    connectedCallback() {
      document.addEventListener(
        'product:variant-changed', 
        this.handleVariantChange.bind(this), 
        { signal: this.abortController.signal },
      );
    }

    handleVariantChange(event) {
      const { variant } = event.detail;
      if (!variant) {
        console.warn('ProductSKU: No variant found in product:variant-changed event. Skipping SKU update.');
        return;
      }
      this.innerHTML = variant.sku;
    }

    disconnectedCallback() {
      this.abortController.abort();
    }
  }

  if (!customElements.get('product-sku')) {
    customElements.define('product-sku', ProductSKU);
  }
  } catch(e) { console.error(e); }
})();

})();
